import ApiHelper from "./ApiHelper";

class JobServices {
  
  static async CreateJob(body) {
    return ApiHelper.postAuthenticated("jobs", body);
  }

  static async DraftJob(body) {
    return ApiHelper.putAuthenticated('draft-job', body);
  }

  static async DeleteJob(body) {
    return ApiHelper.deleteAuthenticated(`jobs/${body.jobId}`, body);
  }

  static async UpdateJob(body) {
    return ApiHelper.putAuthenticated(`jobs/${body.jobId}`, body);
  }

  static async GetJobDescription(body) {
    return ApiHelper.postAuthenticated("jobs/generate-job-description", body);
  }

  static async UpdateJobStatus(body) {
    return ApiHelper.patchAuthenticated(`jobs/${body._id}/status`, body);
  }

  static async SendJobInvite(body) {
    return ApiHelper.postAuthenticated(`jobs/${body.jobId}/invite`, body);
  }

  static async SaveJob(body) {
    return ApiHelper.postAuthenticated(`users/${body.userId}/jobs/${body.jobId}/save`, body);
  }

  static async GetSavedJobs(body) {
    return ApiHelper.getAuthenticated(`saved-jobs/${body.userId}`);
  }

  static async QuestionParser(body) {
    return ApiHelper.postAuthenticated("questions-parser", body);
  }

  static async GetJobs() {
    return ApiHelper.getAuthenticated("jobs");
  }

  static async getJobById(id) {
    return ApiHelper.getAuthenticated(`job/${id}`);
  }

  static async GetJobByIdPublic(body) {
    return ApiHelper.getAnonymous(`public/jobs/${body._id}`);
  }

  static async GetJobByEnterpriseIdPublic(body) {
    return ApiHelper.getAnonymous(`public/jobs/enterprise/${body}`);
  }

  static async ApplyJob(body) {
    return ApiHelper.postAuthenticated(`apply-job/${body._id}/${body.enterpriseID}/${body.jobID}`, body);
  }
}
export default JobServices;

